import React from "react";
import ModalForm from "@ui/Modal/Form";
import t from "../../../../../../i18n";
import Text from "@ui/Text";
import ModalHeader from "@ui/ModalV2/Header";
import ModalLinkedEventFooter from "./ModalFooterDashboardLinkedEvent";
import type { DashboardModelT } from "../../../schema/dashboard";
import ModalV2 from "@ui/ModalV2";
import { useTranslations } from "../../../../../../api/useTranslations";

interface Props {
  editModal: boolean;
  closeEditModal: () => void;
  dashboard: DashboardModelT;
  linkedEventCount: number;
  isLinkedToHome: boolean;
  onEdit: (() => void) | false;
  onDuplication: () => Promise<boolean> | false;
}

const ModalEditLinkedDashboard = ({
  editModal,
  dashboard,
  linkedEventCount,
  isLinkedToHome,
  onEdit,
  onDuplication,
  closeEditModal,
}: Props) => {
  const [loading, setLoading] = React.useState(false);
  const translations = useTranslations();

  const handleDuplicate = React.useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      if (!onDuplication) return;
      setLoading(true);
      try {
        await onDuplication();
        setLoading(false);
      } catch (e) {
        setLoading(false);
        throw e;
      }
    },
    [onDuplication],
  );

  return (
    <ModalV2 isOpen={editModal} onRequestClose={closeEditModal} size="s">
      {onCloseModal => (
        <>
          <ModalHeader
            title={t("project.dashboard.header.modal.form.changed_dashboard", translations)}
            onRequestClose={onCloseModal}
            closable
          />
          <ModalForm
            onSubmit={null}
            cancellable={false}
            onRequestClose={onCloseModal}
            okButtonName={t("project.dashboard.transaction.save.submit_action")}
            cancelButtonName={t("project.dashboard.transaction.save.cancel_action")}
          >
            <Text type="body1">
              {t(
                "project.dashboard.header.modal.form.changed_dashboard.content",
                {
                  dashboardName: dashboard.title,
                  linkedEventCount,
                  isLinkedToHome,
                },
                translations,
              )}
            </Text>
          </ModalForm>
          <ModalLinkedEventFooter
            onCancel={onCloseModal}
            onDuplication={handleDuplicate}
            onEdit={onEdit}
            loading={loading}
          />
        </>
      )}
    </ModalV2>
  );
};

export default ModalEditLinkedDashboard;
